<div
  class="extended-store-heading"
  [ngClass]="{'is-hidden': isModelFeedVisible || isNoDataRecieved || isAdvancedSearchActive}">
  <h1>What are you looking for?</h1>
</div>

<app-advanced-search-navbar
  [libraryButtonMode]="'back'"
  [attachmentsEnabled]="false"
  [isBusy]="isAdvancedSearchBusy"
  [isHidden]="isModelFeedVisible || isNoDataRecieved"
  (libraryClicked)="onLibraryClick()"
  (accountClicked)="onAccountClick()"
  (cancelRequested)="onComposerCancel()"
  (submitRequested)="onComposerSubmit($event)">
</app-advanced-search-navbar>

<div
  [@cardFeedAnimation]="currentAnimationState"
  class="shared-content-page"
  ngClass.lt-sm="shared-content-page-lt-sm"
  ngClass.lt-md="shared-content-page-lt-md"
  ngClass.gt-sm="shared-content-page-gt-sm"
  ngClass.gt-lg="shared-content-page-gt-lg">

  <div class="nodata-wrapper" *ngIf="isNoDataRecieved">
    <h1 class="nodata-title">Something went wrong :(</h1>
    <h3 class="nodata-desc">{{errorData}}</h3>
  </div>

  <div class="advanced-search-feedback" *ngIf="advancedSearchUiState === 'planning' && advancedSearchCards.length === 0">
    <p>Analyzing request and planning previews...</p>
  </div>

  <div
    class="advanced-search-feedback is-error"
    *ngIf="advancedSearchUiState === 'error' && advancedSearchCards.length === 0">
    <h2>Unable to plan previews</h2>
    <p>{{ advancedSearchErrorMessage || 'Please try a different prompt.' }}</p>
  </div>

  <div
    class="advanced-search-feedback is-error is-inline-error"
    *ngIf="advancedSearchCards.length > 0 && hasAdvancedSearchErrors && advancedSearchErrorMessage">
    <h2>Generation details</h2>
    <p>{{ advancedSearchErrorMessage }}</p>
  </div>

  <app-thumbnail-gallery
    *ngIf="advancedSearchCards.length > 0"
    class="no-title zero-margin last-slider ai-generated-gallery"
    [sourceCards]="[]">
    <app-advanced-search-thumb-card
      class="gallery-thumb weblayout"
      *ngFor="let card of advancedSearchCards; trackBy: trackByAdvancedSearchCardId"
      [card]="card"
      (previewOpened)="onAiPreviewSelected($event)"
      (retryRequested)="onAiPreviewRetry($event)">
    </app-advanced-search-thumb-card>
  </app-thumbnail-gallery>

  <div class="store-gallery-overlay" *ngIf="isCollectionDetailsShown">
    <app-thumbnail-gallery
      #thumbnailGallery
      class="no-title zero-margin last-slider"
      [sourceCards]="collectionDetailsSource?.collectionCards ?? []"
      [sortField]="'modifiedDate'"
      (cardClicked)="onStoreThumbClicked($event)">
    </app-thumbnail-gallery>
  </div>

  <div
    [@homeOverscrollAnimation]="isModelFeedVisible"
    class="shared-content-overscroll-background"
    *ngIf="isModelFeedVisible"></div>

  <app-web-models-card
    @modelFeedAnimation
    [feedMode]="CARDS_MODE.COMPOSITE_FEED"
    [feedModificator]="activeFeedModificator"
    #modelCardsFeed
    class="feed-overlap model-feed"
    *ngIf="isModelFeedVisible"
    [startPosition]="modelFeedCardStartPosition"
    [feedIsVisible]="isModelFeedVisible"
    [cardsRaw]="modelFeedCards"
    (actionBtnClicked)="onCardCollectionControlBtnClicked($event)"
    (cardVisibilityChanged)="onCardVisibilityChanged($event)">
  </app-web-models-card>
</div>
